"use strict";
import React from "react";
import { Link } from "react-router-dom";
import FormsyFields from "./formsyFields";
import Formsy from "./formsy";
import PrismIcon from "./prism/icon/prismIcon";
import { isEmailValid } from '../../../shared/js/util/validationUtils';
const loaders = require("./loaders");

const initComponent = (flex = window.flex) => {

    class ForgotUsername extends React.PureComponent {
        state = {
            returnData: [],
            canSubmit: false,
            dataReady: true,
            alertMsg: "",
            isPristine: true
        };

        emailAddressValidation = {
            validators: {
                required: model => !!model['emailAddress'],
                email: model => isEmailValid(model['emailAddress'])
            },
            errorMessages: {
                required: 'Email address is required.',
                email: 'Please check the email format.'
            }
        };

        enableButton = () => {
            this.setState({
                canSubmit: true
            });
        };

        disableButton = () => {
            this.setState({
                canSubmit: false
            });
        };

        handleSubmit = (model, reset, invalidate) => {
            const self = this;
            self.setState({ dataReady: true, canSubmit: false });
            var activeSpinner = flex.showSpinner(document.querySelector('.ladda-button'));
            $.ajax({
                url: flex.getApiUrl("/api/v1/auth/forgotusername"),
                async: true,
                type: "POST",
                dataType: "json",
                data: JSON.stringify(model),
                contentType: "application/json",
                headers: flex.getHeaders(),
                success: function (data) {
                    if (!this.unmounting) {
                        self.setState(
                            {
                                returnData: data.values || null,
                                alertMsg: `Thanks for your request. If your email address is verified, you'll receive an email with your username. 
                                    ${flex.text("UX_CONTACT_CLIENT_CARE", "For assistance, please contact Client Care")}`,
                                dataReady: true,
                                canSubmit: false
                            });
                        flex.hideSpinner(activeSpinner);
                    }
                }.bind(this),
                error: function (jqXHR, textStatus, errorThrown) {
                    flex.handleAjaxError(jqXHR, textStatus, errorThrown);
                    self.setState({ returnData: [], alertMsg: jqXHR.responseJSON.msg, canSubmit: false, dataReady: true });
                    flex.hideSpinner(activeSpinner);
                }
            });
        };

        onHandleIsPristineChange = () => {
            if (this.state.isPristine) {
                this.setState({ isPristine: false })
            }
        };

        render() {
            const self = this;
            if (!self.state.dataReady) return loaders.loader;

            const formProps = { layout: "vertical" };
            const emailPlaceholder = flex.text("UX_LOGIN_LBL_EMAIL_ADDRESS", "Email Address");

            const returnData = self.state.returnData;
            const alertMsg = self.state.alertMsg;

            const results = alertMsg ?
                <div>
                    <div className="form-group">
                        <div className="row forgot-username__continue">
                            <div className="col-xs-12">
                                <Link className="btn ladda-button" to="/">{flex.text("UX_ACT_CONTINUE", "CONTINUE")}</Link>
                            </div>
                        </div>
                    </div>
                </div>
                : <div>
                    <div className="forgot-username__text-instruction">
                        <span>Enter your email address to receive an email with your username.</span>
                    </div>

                    <div className="forgot-username__input-email">
                        <FormsyFields.Input
                            {...formProps}
                            id="emailAddress"
                            name="emailAddress"
                            labelClassName="sr-only"
                            placeholder={emailPlaceholder}
                            type="email"
                            autoFocus={true}
                            validations={this.emailAddressValidation.validators}
                            validationErrors={this.emailAddressValidation.errorMessages}
                            isPristine={() => self.state.isPristine}
                            onChange={this.onHandleIsPristineChange}
                            onClick={e => { e.stopPropagation(); }}
                        />
                        <PrismIcon
                            className="forgot-username__input-email__icon-envelope"
                            iconClassName="icon prism-icon-envelope"
                        />
                    </div>

                    <div className="form-group">
                        <div className="forgot-username__action-button">
                            <div className="col-xs-4 forgot-username__forgot-password-button">
                                <Link to="/forgotpassword" className="btn btn-cancel">{flex.text("UX_ACT_FORGOT_PASSWORD","Forgot Password")}</Link>
                            </div>
                            <div className="col-xs-2 col-md-2">
                                <Link className="btn btn-cancel" to="/">{flex.text("UX_ACT_CANCEL")}</Link>
                            </div>
                            <div className="col-xs-6">
                                <button
                                    className="btn ladda-button"
                                    type="submit"
                                    disabled={!this.state.canSubmit}
                                >
                                    {flex.text("UX_ACT_SEND_REQUEST", "Send Request")}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>;

            return (
                <div style={{ margin: "40px auto", width: 360 }}>
                    <div>
                        <Formsy.Form style={{ textAlign: "left" }} onValidSubmit={this.handleSubmit} onValid={this.enableButton} onInvalid={this.disableButton}>
                            <fieldset>
                                <h1 className="forgot-username__title">{flex.text("UX_FORGOT_USERNAME_TITLE_LBL", "Username Recovery")}</h1>
                                <p className="label-offset">{alertMsg}</p>
                                {results}
                            </fieldset>
                        </Formsy.Form>
                    </div>
                </div>
            );
        }
    }

    return ForgotUsername;
};

module.exports = initComponent;
